<template>
  <div v-if="stockOrderOut && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <OnePiecePrint :formater="formater" :data="stockOrderOut" />
  </div>
</template>
<script>
import StockOuts from "@/api/stock_outs";

import PrintTemplates from "@/api/print_templates";
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";
import makeData from "./makeData";
import { mapState } from "vuex";

export default {
  components: {
    OnePiecePrint,
  },

  data: () => ({
    formater: null,
    stockOrderOut: {},
  }),

  computed: {
    ...mapState(["accountUser"]),
  },

  mounted() {
    PrintTemplates.fetchOne("stockOrderOut").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.template;
          this.formater = formater;
          //获取单据详情
          StockOuts.orderOutPrint(this.$route.params.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.stockOrderOut = response.data.stock_out;

                if (!this.stockOrderOut.order_address)
                  this.stockOrderOut.order_address =
                    response.data.order_address;
                this.stockOrderOut.printDateMinutes =
                  this.$datetimeUtils.formatDateMinutes(new Date());
                this.stockOrderOut.accountUserName = this.accountUser.name;
                this.stockOrderOut = makeData.processDetails(
                  this.stockOrderOut
                );
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>